const TAG_ALIASES = {
  muestras: "Muestras",
  samples: "Muestras",
  "samples location": "Muestras",
  logistica: "Logística",
  logistics: "Logística",
  logistic: "Logística",
  pedidos: "Pedidos",
  orders: "Pedidos",
  "orders view": "Pedidos",
  estimates: "Estimates",
  "critical path": "Critical Path",
  criticalpath: "Critical Path",
  "critical path gantt": "Critical Path",
  gastos: "Gastos",
  expenses: "Gastos",
  tareas: "Tareas",
  tasks: "Tareas",
  "todo list": "Tareas",
  todolist: "Tareas",
  diseno: "Diseño",
  design: "Diseño",
  designs: "Diseño",
  notas: "Notas",
  notes: "Notas",
  admin: "Admin",
  administration: "Admin",
  clients: "Clientes",
  clientes: "Clientes",
  fichar: "Fichar",
  chat: "Chat",
  dashboard: "Dashboard",
  "dashboard admin": "Dashboard",
  emails: "Emails",
  ai: "AI",
  pyg: "Analítica",
  "pyg analitico": "Analítica",
  "pyg analitic": "Analítica",
  analitica: "Analítica",
  wages: "Nóminas",
  nominas: "Nóminas",
  sidebar: "Sidebar",
  sales: "Sales",
  knowledge: "Conocimiento",
  suppliers: "Proveedores",
  users: "Users",
  cashflow: "CashFlow",
  materialoteca: "Materialoteca",
  management: "Management",
  languages: "Languages",
  various: "Varios",
  all: "General",
  general: "General",
  news: "General",
  envios: "Envíos",
  projects: "Proyectos",
  costs: "Costes",
};

export const NUEVOS_TAG_KEY = "__nuevos__";

const TAG_COLORS = {
  [NUEVOS_TAG_KEY]: "#00b894",
  muestras: "#7c3aed",
  logistica: "#ea580c",
  pedidos: "#2563eb",
  estimates: "#0f766e",
  "critical path": "#4f46e5",
  gastos: "#db2777",
  clientes: "#0284c7",
  tareas: "#16a34a",
  diseno: "#c026d3",
  notas: "#ca8a04",
  admin: "#57534e",
  chat: "#0891b2",
  dashboard: "#4338ca",
  emails: "#e11d48",
  ai: "#6d28d9",
  analitica: "#0d9488",
  nominas: "#be185d",
  envios: "#d97706",
  fichar: "#059669",
  sidebar: "#64748b",
  sales: "#dc2626",
  conocimiento: "#0ea5e9",
  proveedores: "#b45309",
  materialoteca: "#8b5cf6",
  general: "#475569",
  varios: "#78716c",
  proyectos: "#1d4ed8",
  costes: "#b91c1c",
  tarjetas: "#6366f1",
};

const TAG_PALETTE = [
  "#7c3aed",
  "#ea580c",
  "#2563eb",
  "#0f766e",
  "#db2777",
  "#16a34a",
  "#0284c7",
  "#c026d3",
  "#d97706",
  "#4f46e5",
  "#e11d48",
  "#0d9488",
];

function hashHue(value) {
  const src = String(value || "");
  let hash = 0;
  for (let i = 0; i < src.length; i += 1) {
    hash = (hash * 31 + src.charCodeAt(i)) >>> 0;
  }
  return hash;
}

export function novedadTagColor(tagKey) {
  if (tagKey === NUEVOS_TAG_KEY) return TAG_COLORS[NUEVOS_TAG_KEY];
  const folded = foldNovedadTag(normalizeNovedadTag(tagKey));
  if (TAG_COLORS[folded]) return TAG_COLORS[folded];
  return TAG_PALETTE[hashHue(folded) % TAG_PALETTE.length];
}

export function foldNovedadTag(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

export function parseNovedadTags(raw) {
  if (!raw || typeof raw !== "string") return [];
  return raw
    .split(/[,;/|]+/)
    .map((part) => part.trim())
    .filter(Boolean);
}

function prettyTag(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function normalizeNovedadTag(tag) {
  const folded = foldNovedadTag(tag);
  if (!folded) return "General";
  return TAG_ALIASES[folded] || prettyTag(tag);
}

export function novedadTagLabels(item) {
  const parsed = parseNovedadTags(item?.Tags);
  const source = parsed.length ? parsed : parseNovedadTags(item?.Titulo);
  const labels = (source.length ? source : ["General"]).map(normalizeNovedadTag);
  return [...new Set(labels)];
}

function toTime(value) {
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : 0;
}

export function groupNovedadesByTag(items) {
  const map = new Map();
  (items || []).forEach((item) => {
    novedadTagLabels(item).forEach((label) => {
      const key = foldNovedadTag(label);
      if (!map.has(key)) {
        map.set(key, {
          key,
          label,
          items: [],
          nuevoCount: 0,
          latestFecha: null,
        });
      }
      const group = map.get(key);
      group.items.push(item);
      if (item.nuevo) group.nuevoCount += 1;
      if (!group.latestFecha || toTime(item.Fecha) > toTime(group.latestFecha)) {
        group.latestFecha = item.Fecha;
      }
    });
  });

  return [...map.values()]
    .map((group) => ({
      ...group,
      items: [...group.items].sort(
        (a, b) => (b.Id || 0) - (a.Id || 0) || toTime(b.Fecha) - toTime(a.Fecha),
      ),
    }))
    .sort((a, b) =>
      a.label.localeCompare(b.label, "es", { sensitivity: "base" }),
    );
}

export function rememberNuevosIds(items, remembered) {
  const next = remembered instanceof Set ? remembered : new Set();
  (items || []).forEach((item) => {
    if (item.nuevo) next.add(Number(item.Id));
  });
  return next;
}

export function itemsForNovedadTag(items, tagKey, keepIds) {
  const list = items || [];
  if (!tagKey) return list;
  if (tagKey === NUEVOS_TAG_KEY) {
    const keep = keepIds instanceof Set ? keepIds : null;
    return list.filter(
      (item) => item.nuevo || (keep && keep.has(Number(item.Id))),
    );
  }
  return list.filter((item) =>
    novedadTagLabels(item).some((label) => foldNovedadTag(label) === tagKey),
  );
}
